// angular
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MeRegisterService } from '../../register/me-register.service';

@Component({
    selector: 'me-registration-success',
    templateUrl: './registration-success.component.html',
    styleUrls: ['./registration-success.component.scss'],
})

export class MeRegistrationSuccessComponent implements OnInit {
    data = null;
    url = 'success/registration-success';

    @Output() toDashboard = new EventEmitter<any>();

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public meRegisterService : MeRegisterService
    ) {

    }

    ngOnInit() {
        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'];
        });
    }

    gotoDashboard() {
        this.toDashboard.emit();
    }
}
